import type { NotificationGroupedByDate } from '../../interface/Notification';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

export const useGetNotifications = () => {
  const authToken = getCookie(authKeys.authToken);
  return useQuery({
    queryKey: ['customer', 'notifications'],
    queryFn: getNotifications,
    select: (data) => {
      for (const key in data) {
        const date = key as keyof NotificationGroupedByDate;
        if (data[date].length === 0) {
          delete data[date];
        }
      }
      return data;
    },
    enabled: !!authToken,
  });
};

const getNotifications = async (): Promise<NotificationGroupedByDate> => {
  const { data } = await api.get<{ data: NotificationGroupedByDate }>(
    apiConfig.routes.notifications
  );
  return data.data;
};
